(() => {
 if(window.ugRandomModelsReady)return;
 window.ugRandomModelsReady=true;
 const states=new Map(),feeds=new Map();
 const shuffle=items=>{const out=[...items];for(let i=out.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[out[i],out[j]]=[out[j],out[i]];}return out;};
 const choose=(pool,count,previous)=>{
  if(count<=0)return [];
  const items=shuffle(pool),picks=items.slice(0,count);
  if(items.length>count&&picks.every(x=>previous.includes(x.id))){
   const other=items.slice(count).find(x=>!previous.includes(x.id));
   if(other)picks[picks.length-1]=other;
  }
  if(picks.length>1&&picks.map(x=>x.id).join(',')===previous.join(','))picks.push(picks.shift());
  return picks;
 };
 async function fetchPool(path){
  const initial=new URL(path,location.origin);
  const key=initial.pathname+initial.search;
  if(feeds.has(key))return feeds.get(key);
  const task=(async()=>{
   const pool=new Map(),visited=new Set();
   let next=initial;
   const preview=new URL(location.href).searchParams.get('preview_theme_id');
   while(next){
    if(next.origin!==location.origin)throw new Error('Invalid collection origin');
    if(initial.searchParams.has('q'))next.searchParams.set('q',initial.searchParams.get('q'));
    next.searchParams.set('section_id','ug-brand-feed');
    if(preview)next.searchParams.set('preview_theme_id',preview);
    if(visited.has(next.href))break;visited.add(next.href);
    const response=await fetch(next.href,{cache:'no-store'});
    if(!response.ok)throw new Error('Collection unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const root=doc.querySelector('[data-ug-brand-feed]');
    if(!root)throw new Error('Missing collection');
    root.querySelectorAll('template[data-ug-brand-card]').forEach(template=>{
     if(template.dataset.available==='false')return;
     const card=template.content.firstElementChild;
     if(card)pool.set(template.dataset.productId,{id:template.dataset.productId,card});
    });
    const link=root.querySelector('[data-ug-brand-next]');
    next=link?new URL(link.getAttribute('href'),next):null;
   }
   return [...pool.values()];
  })();
  feeds.set(key,task);
  task.catch(()=>feeds.delete(key));
  return task;
 }
 const visible=root=>{const rect=root.getBoundingClientRect();return !root.hidden&&rect.width>0&&rect.bottom>0&&rect.top<innerHeight;};
 function render(state){
  const root=state.root;
  if(!root.isConnected||!state.pool?.length||document.hidden||performance.now()<(state.restoreUntil||0))return;
  const count=Number(root.dataset.randomCount)||4;
  const key='ug-random-picks:'+root.dataset.randomFeed+':'+(root.dataset.randomExclude||'');
  let previous=state.previous||[];
  if(!state.previous)try{previous=JSON.parse(localStorage.getItem(key)||'[]');if(!Array.isArray(previous))previous=[];}catch{}
  const primary=state.primary||state.pool;
  const first=choose(primary,count,previous);
  const primaryIds=new Set(primary.map(x=>x.id));
  const picks=first.concat(choose(state.pool.filter(x=>!primaryIds.has(x.id)),count-first.length,previous));
  root.querySelector('.ugx-grid').replaceChildren(...picks.map(x=>x.card.cloneNode(true)));
  state.previous=picks.map(x=>x.id);
  try{localStorage.setItem(key,JSON.stringify(state.previous));}catch{}
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches)root.querySelector('.ugx-grid').animate([{opacity:.65},{opacity:1}],{duration:180});
  window.ugProductFit?.scan();
 }
 async function start(state){
  if(state.loading||state.pool)return;
  state.loading=true;
  try{
   const root=state.root,exclude=root.dataset.randomExclude;
   let pool=(await fetchPool(root.dataset.randomFeed)).filter(x=>x.id!==exclude);
   const brandCount=pool.length;
   state.primary=pool;
   const count=Number(root.dataset.randomCount)||4;
   if(pool.length<count&&root.dataset.randomFill==='true'){
    const fallback=await fetchPool((window.Shopify?.routes?.root||'/')+'collections/all');
    const ids=new Set(pool.map(x=>x.id));
    pool=pool.concat(fallback.filter(x=>x.id!==exclude&&!ids.has(x.id)));
   }
   state.pool=pool;
   if(root.dataset.randomVendor){
    root.querySelector('.ugx-title').textContent=brandCount?root.dataset.randomHeading:root.dataset.randomFallback;
   }
   render(state);
   state.lastSwap=performance.now();
  }catch{}finally{state.loading=false;}
 }
 const observe=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){const state=states.get(entry.target);if(state)start(state);}}),{rootMargin:'200px'});
 function scan(){
  document.querySelectorAll('[data-random-feed]').forEach(root=>{
   if(states.has(root)||!root.dataset.randomFeed||!root.querySelector('.ugx-grid'))return;
   const state={root,lastInteraction:0,lastSwap:0};states.set(root,state);observe.observe(root);
   ['pointerdown','pointermove','focusin','wheel','touchstart'].forEach(type=>root.addEventListener(type,()=>state.lastInteraction=performance.now(),{passive:true}));
  });
  for(const [root]of states)if(!root.isConnected){observe.unobserve(root);states.delete(root);}
 }
 scan();
 let scheduled=false;
 new MutationObserver(()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;scan();});}}).observe(document.getElementById('MainContent')||document.body,{childList:true,subtree:true});
 window.addEventListener('scroll',()=>{const now=performance.now();states.forEach(state=>state.lastInteraction=now);},{passive:true});
 setInterval(()=>{
  if(document.hidden||document.querySelector('cart-drawer.active,dialog[open]'))return;
  const now=performance.now();
  states.forEach(state=>{
   if(!visible(state.root))return;
   if(!state.pool){start(state);return;}
   if(((matchMedia('(hover: hover)').matches&&state.root.matches(':hover'))||state.root.matches(':focus-within'))||now-state.lastInteraction<4000||now-state.lastSwap<12000)return;
   if(state.pool.length>(Number(state.root.dataset.randomCount)||4)){render(state);state.lastSwap=now;}
  });
 },1000);
 window.addEventListener('pagehide',()=>states.forEach(state=>state.restoreUntil=Infinity));
 window.addEventListener('pageshow',event=>{if(event.persisted){const now=performance.now();states.forEach(state=>{state.restoreUntil=now+12000;state.lastInteraction=now;state.lastSwap=now;});}});
})();
